<template>
  <a-layout class='index animated fadeIn'>
    <a-card>
      <a-tabs  @change="callback" v-model:activeKey="activeKey">
        <a-tab-pane :key="1" tab="代码同步记录">
             <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
                <template v-slot:action="{ record }" >
                  <a-dropdown v-if="activeKey==1">
                    <a class="ant-dropdown-link"> 操作
                      <DownOutlined />
                    </a>
                    <template v-slot:overlay>
                      <a-menu>
                        <a-menu-item  >
                          <a v-has:synchroRecordDetails="()=>appletReleaseCodeDetail(record)" href="javascript:;">详情</a>
                        </a-menu-item>
                           <a-menu-item  >
                          <a v-has:appletCodeReview="()=>appletCodeReview(record)" href="javascript:;">一键审核</a>
                        </a-menu-item>
                           <a-menu-item  >
                          <a v-has:appletCodeReviewFast="()=>fastAppletCodeReview(record)" href="javascript:;">加急审核</a>
                        </a-menu-item>
                        <!-- <a-menu-item v-if="record.status!=1">
                          <a v-has:appletCodeReview="()=>appletCodeReview(record)" href="javascript:;">重新提交</a>
                        </a-menu-item> -->
                      </a-menu>
                    </template>
                  </a-dropdown>
                </template>
              </a-table>
              <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `" />
        </a-tab-pane>
        <a-tab-pane :key="2" tab="代码审核记录">
          <appletRelease />
        </a-tab-pane>
      </a-tabs>
     
    </a-card>
  </a-layout>
  <a-modal v-model:visible="visible" title="审核" @ok="handleOk" centered :confirm-loading="confirmLoading" destroyOnClose :width="1000" :height="600">
    <a-table :pagination='false' :loading='listLoading' :columns='columns1' :data-source='data'>
    </a-table>
    <p class="mb10" style="color:#f04635">是否要确定批量重新审核失败的小程序么？</p>
  </a-modal>
  <a-modal v-model:visible="detailVisible" title="详情" @ok="handleOk" centered :confirm-loading="confirmLoading" destroyOnClose :width="1200" :height="600">
    <a-tabs @change="detailCallback">
      <a-tab-pane :key="1" tab="成功">
      </a-tab-pane>
      <a-tab-pane :key="0" tab="失败">
      </a-tab-pane>
    </a-tabs>
    <a-table :pagination='false' :loading='listLoading' :columns='columns1' :data-source='detailData'>
    </a-table>
  </a-modal>
</template>
<script>
import { DownOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
import appletRelease from './components/appletRelease'
import { setAgentDisable, getAgentLevelList } from "@/api/agent";
import {
  getMinidraftList,
  delMiniapp,
  getMiniappBatchIndex,
  getsubmitAuditAll,
  getMiniappBatchDetail,
  getAuditDetail,
  submitAuditSpeed,
  submitAuditwhole
} from "@/api/appletCode";
import { $iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
};
export default {
  components: { DownOutlined ,appletRelease},
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      listLoading: false,
      total: 1,
      active: 1,
      activeKey:1,
      visible: false,
      detailVisible: false,
    });
    let columns = [
      {
        title: "模板名称",
        dataIndex: "user_version",
        key: "user_version",
        width: 150,
      },
      {
        title: "版本号",
        dataIndex: "user_version",
        key: "user_version",
        width: 150,
      },
      {
        title: "版本描述",
        dataIndex: "user_desc",
        key: "user_desc",
      },
      {
        title: "状态",
        dataIndex: "status_text",
        key: "status_text",
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
        width: 200,
      },
      {
        title: "操作",
        key: "action",
        fixed: "right",
        width: 100,
        slots: { customRender: "action" },
      },
    ];
    let columns1 = [
      {
        title: "版本号",
        dataIndex: "user_version",
        key: "user_version",
        width: 150,
      },
      {
        title: "版本描述",
        dataIndex: "user_desc",
        key: "user_desc",
      },
      {
        title: "appID",
        dataIndex: "app_id",
        key: "app_id",
        width: 200,
      },
      {
        title: "小程序名称",
        key: "nick_name",
        dataIndex: "nick_name",
      },
      {
        title: "品牌商编号",
        dataIndex: "brand_id",
        key: "brand_id",
      },
      {
        title: "模板名称",
        dataIndex: "template_name",
        key: "template_name",
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 小程序模板添加至草稿箱
    const agentDraftToTempalte = async (e) => {
      let res = await addTemplate({ draft_id: e.draft_id }).then(
        (res) => res.data
      );
      $iscode(res, true);
    };
    //小程序列表
    const initData = async (values) => {
      state.listLoading = true;
      let res={}
      if(state.activeKey==1){
       res = await getMiniappBatchIndex(values).then((res) => res.data);
      }else{
       res = await getsubmitAuditAll(values).then((res) => res.data);
      }
      state.listLoading = false;
      if ($iscode(res)) {
        data.value = res.data.data;
        state.total = res.data.total;
      }
    };
    onMounted(() => {
      initData(search.value);
    });
    // 删除
    const appletDel = (data) => {
      $Modal.confirm({
        content: "确定要删除该模板么",
        onOk: async () => {
          let res = await delMiniapp({ template_id: data.template_id }).then(
            (res) => res.data
          );
          if ($iscode(res, true)) {
            initData(search.value);
          }
        },
      });
    };
    // 添加模板至草稿箱
    const addTemplate = (data) => {
      $Modal.confirm({
        content: "确定要删除该模板么",
        onOk: async () => {
          let res = await delMiniapp({ template_id: data.template_id }).then(
            (res) => res.data
          );
          if ($iscode(res, true)) {
            initData(search.value);
          }
        },
      });
    };
    // 审核
    const appletCodeReview = async(data) => {
        const hide = message.loading("正在加载中...", 0);
      // state.visible = true;
      let result=await submitAuditwhole({code_group_id:data.id}).then(res=>res.data).catch(error=>error)
      setTimeout(hide);
      $iscode(result,true)
    };
    const detailSearch=ref({
      page:1,
      limit:1000,
      status:1
    })
    const detailData=ref()
    const group_id=ref()
    const appletReleaseCodeDetail =async (values) => {
      group_id.value=values.id
      let res = await getMiniappBatchDetail({...detailSearch.value,group_id:values.id}).then((res) => res.data);
      detailData.value=res.data.data
      state.detailVisible = true;
    };
    const detailCallback=(e)=>{
        detailSearch.value.status=e
        detailSearch.value.page=1
        appletReleaseCodeDetail({id:group_id.value})
    }
    const callback=()=>{
      search.value.page=1
      initData(search.value);
    }

    const fastAppletCodeReview=async (e)=>{
        $Modal.confirm({
        content: "确定加急审核么?一个小程序一年只有三次加急机会",
        onOk: async () => {
             let result=await submitAuditSpeed({id:e.id}).then(res=>res.data).catch(error=>error)
            $iscode(result,true)
        },
      });
 
    }
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      addTemplate,
      agentDraftToTempalte,
      appletDel,
      appletCodeReview,
      columns1,
      appletReleaseCodeDetail,
      callback,
      detailData,
      detailCallback,
      fastAppletCodeReview
    };
  },
};
</script>